import router from './router'
import { resetRouter } from './router/index'
import store from './store'
import { Message } from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie

NProgress.configure({ showSpinner: false }) // NProgress Configuration

//路由白名单
const whiteList = ['/login', '/smsPrivacyPolicy', '/yipaiPrivacyPolicy', '/cloudDispatchPrivacyPolicy', '/selfServicePrivacyPolicy', '/selfServiceUserAgreement'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()

  // set page title
  document.title = '格力再生资源管理平台'

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      const hasGetUserInfo = store.getters.name
      if (hasGetUserInfo) {
        if (to.matched.length === 0) {
          Message.warning('没有该页面权限或找不到该页面')
          next('/homeBoard')
        } else {
          next()
        }
      } else {
        // 新增判断：防止重复进入相同路由造成死循环
        if (from.path === to.path) {
          next()
          return
        }
        try {
          // 先重置路由，避免旧路由残留导致匹配问题
          resetRouter()
          store.state.permission.addRouters = []

          // get user info
          await store.dispatch('user/getInfo')
          const { data, lastPageData } = await store.dispatch('user/getRouteAuth')
          store.commit('SET_ROUTERS', data)
          // console.log('=======router', router)
          router.addRoutes(lastPageData)

          // 如果没有菜单权限，直接跳转到首页看板
          if (!lastPageData || lastPageData.length === 0) {
            next('/homeBoard')
          } else {
            next({ ...to, replace: true })
          }
        } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          Message.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        }
      }
    }
  } else {
    /* has no token*/
    console.log('to.path', to.path)
    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js